import { render, staticRenderFns } from "./ImageQuestion.vue?vue&type=template&id=8ca57f70&"
import script from "./ImageQuestion.vue?vue&type=script&lang=js&"
export * from "./ImageQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports